
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export const noop = () => {};

export { getCurrencyFormat } from './getCurrencyFormat';
export { canEditCreditLine } from './canEditCreditLine';
export { setTabsWithCreditLine } from './setTabsWithCreditLine';
export * from './roles';
